<template>
  <div class="item"
    :class="{bookmark: item.bookmark}"
    @click="remoteTv(item)">
    <p class="name">{{item.name}}</p>
    <p class="no">{{item.no}}</p>
    <img :src="item.logo" :alt="item.name" />
    <button type="button" class="btnBookmark"
      @click.prevent="onClickBookmark">
      <span class="blind">bookmark</span>
    </button>
    <TvLoading v-if="isTvLoading" />
  </div>
</template>

<script>
import TvLoading from '@/components/TvControl/TvLoading'

export default {
  name: 'ChannelItem',
  props: [
    'lang',
    'locale',
    'item',
    'isControl',
    'tvIndex'
  ],
  components: {
    TvLoading
  },
  computed: {
    partner () {
      return this.$store.state.system.partner.name
    },
    isCoreGuide () {
      return this.partner === 'CoreGuide'
    }
  },
  data () {
    return {
      remoteIndex: 0,
      isTvLoading: false
    }
  },
  methods: {
    remoteNo () {
      const i = this.remoteIndex
      const no = this.item.no.split('')
      const data = {
        cmd: no[i],
        tv: '0',
        type: 'button'
      }
      if (data.cmd) {
        this.$store.dispatch('tv/setTvControl', data).then((res) => {
          if (!res) {
            this.$emit('toast')
            this.isTvLoading = false
          } else {
            if (i < no.length - 1) {
              this.remoteIndex += 1
              this.remoteNo()
            } else {
              this.remoteIndex = 0
              this.isTvLoading = false
            }
          }
        })
      } else {
        this.isTvLoading = false
      }
    },
    remoteTv (item) {
      this.isTvLoading = true
      const data = {
        cmd: item.no,
        tv: this.tvIndex,
        type: 'channel'
      }
      this.$store.dispatch('tv/setTvControl', data).then((res) => {
        if (res.data && res.data.status === 403) {
          const message = res.data.message.includes('notSupported')
            ? 'notSupported'
            : res.data.message.includes('fail')
              ? 'fail'
              : 'fail'
          this.$emit('toast', message)
        }
        this.isTvLoading = false
      })
    },
    onClickBookmark (e) {
      this.$emit('bookmark', this.item.id)
      e.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
.btnBookmark {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 5px;
  font-size: 0;
  &:before {
    content: "\2606";
    font-size: 24px;
    color: $color-grey;
    line-height: 1;
  }
}
.bookmark {
  .name {
    color: $color-dark;
  }
  .btnBookmark {
    &:before {
      content: "\2605";
      font-size: 25px;
      color: #ffb203;
    }
  }
}
</style>
